// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/img/back_2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/img/back_1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23333%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
    overflow-x: hidden;
}

html {
    overflow-x: hidden;
}

.page {
    display: none;
    min-height: 100vh;
}

.page.active {
    display: block;
}

/* Главная страница */
.main-page {
    background: #f5f7fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

/* Черный хедер */
.main-header {
    background-color: #1E1E1E;
    padding: 30px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
}

.header-logo {
    display: flex;
    align-items: center;
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
}

.header-logo-img {
    height: 45px;
    width: auto;
    max-width: 100%;
    max-height: 45px;
    object-fit: contain;
    display: block;
}

/* Дополнительная адаптивность для очень маленьких экранов */
@media (max-width: 480px) {
    .header-logo-img {
        max-width: calc(100vw - 100px) !important;
    }
}

@media (max-width: 360px) {
    .header-logo-img {
        max-width: calc(100vw - 80px) !important;
    }
}

@media (max-width: 320px) {
    .header-logo-img {
        max-width: calc(100vw - 60px) !important;
    }
}

.header-buttons {
    display: flex;
    gap: 15px;
}

.header-button {
    background: #0058AA;
    color: #ffffff;
    text-decoration: none;
    padding: 12px 30px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
}

.header-button:hover {
    background-color: #004080;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 88, 170, 0.4);
}

.main-content {
    display: flex;
    flex: 1;
    padding: 40px;
    gap: 30px;
    justify-content: center;
    align-items: center;
    max-width: 1500px;
    margin: 0 auto;
    width: 100%;
    min-height: calc(100vh - 100px);
}

.main-left-section {
    width: 714px;
    height: 355px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-right-section {
    width: 714px;
    height: 355px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-left-section:hover,
.main-right-section:hover {
    transform: scale(1.02);
}

.main-left-section:hover::before,
.main-right-section:hover::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
}

.section-link {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: inherit;
}

.section-content {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 20px;
    text-align: center;
}

.org-title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
}

.title-line {
    font-family: 'Roboto', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 34px;
    color: white;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
}

.org-button {
    border: none;
    cursor: pointer;
    padding: 12px 32px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    min-width: 220px;
    text-decoration: none;
    display: inline-block;
    text-align: center;
    pointer-events: none;
}

.org-button-white {
    background: white;
    color: #1e293b;
}

.section-link:hover .org-button-white.org-button-college {
    background-color: #0058AA;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 88, 170, 0.4);
}

.section-link:hover .org-button-white.org-button-university {
    background-color: #009F9B;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 159, 155, 0.4);
}


/* Страница расписания */
.schedule-header {
    background-color: #1E1E1E;
    color: white;
    padding: 40px 20px;
    text-align: center;
    position: relative;
}

.schedule-header h1 {
    font-family: 'Roboto', sans-serif;
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
    margin: 0;
    padding-left: 240px;
    padding-right: 240px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    line-height: 1.3;
}

.back-logo {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: opacity 0.3s;
    text-decoration: none;
    margin-left: 10px;
}

.back-logo:hover {
    opacity: 0.8;
}

.back-logo-img {
    width: 212px;
    height: 77px;
    object-fit: contain;
    max-width: 100%;
}

.schedule-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

/* Вкладки */
.tabs {
    display: flex;
    gap: 0;
    background-color: white;
    border-bottom: 2px solid #e0e0e0;
    margin-bottom: 20px;
    justify-content: center;
}

.tab {
    padding: 15px 30px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    border-bottom: 3px solid transparent;
    transition: all 0.3s;
}

.tab:hover {
    color: #333;
    background-color: #f9f9f9;
}

.tab.active {
    color: #009F9B;
    border-bottom-color: #009F9B;
    font-weight: 500;
}

/* Фильтры */
.filters-container {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    margin-bottom: 30px;
}

.filter-section {
    display: none;
}

.filter-section.active {
    display: block;
}

.filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    gap: 15px;
}

.filter-row label {
    min-width: 120px;
    font-weight: 500;
    color: #333;
}

.select-wrapper {
    flex: 1;
    position: relative;
}

.select-wrapper select {
    width: 100%;
    padding: 10px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    cursor: pointer;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right 10px center;
    padding-right: 35px;
}

.select-wrapper select:focus {
    outline: none;
    border-color: #009F9B;
}

input[type="date"] {
    flex: 1;
    padding: 10px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    color: #1E1E1E;
    background-color: #ffffff;
}

input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
}

input[type="date"]::-webkit-datetime-edit-text {
    color: #1E1E1E;
}

input[type="date"]::-webkit-datetime-edit-month-field,
input[type="date"]::-webkit-datetime-edit-day-field,
input[type="date"]::-webkit-datetime-edit-year-field {
    color: #1E1E1E;
}

input[type="date"]:focus {
    outline: none;
    border-color: #009F9B;
}

.search-wrapper {
    flex: 1;
    position: relative;
}

.custom-select {
    position: relative;
    width: 100%;
}

.custom-select-input {
    width: 100%;
    padding: 10px 35px 10px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right 10px center;
}

.custom-select-input:focus {
    outline: none;
    border-color: #009F9B;
}

.custom-select-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1000;
    display: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.custom-select-dropdown.active {
    display: block;
}

.custom-select-search {
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
}

.custom-select-search input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.custom-select-search input:focus {
    outline: none;
    border-color: #009F9B;
}

.custom-select-options {
    max-height: 250px;
    overflow-y: auto;
}

.custom-select-option {
    padding: 10px 15px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.custom-select-option:hover {
    background-color: #f5f5f5;
}

.custom-select-option.selected {
    background-color: #e3f2fd;
    color: #009F9B;
    font-weight: 500;
}

.custom-select-option.hidden {
    display: none;
}

.load-button {
    width: 100%;
    padding: 15px;
    background-color: #009F9B;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 10px;
    transition: background-color 0.3s;
}

.load-button:hover {
    background-color: #007a77;
}

.load-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

/* Отображение расписания */
.schedule-display {
    margin-top: 30px;
}

.weekly-schedule {
    margin-top: 30px;
    padding-bottom: 40px;
}

.weekly-header {
    margin-bottom: 25px;
    text-align: center;
}

.weekly-title {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 8px;
}

.weekly-date-range {
    font-size: 16px;
    color: #666;
    font-weight: 500;
}

.weekly-days-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    padding-bottom: 10px;
    will-change: scroll-position;
    contain: layout style paint;
}

.day-card {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    border: none;
    display: flex;
    flex-direction: column;
    width: 100%;
    will-change: transform;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.day-card.today {
    border: 4px solid #009F9B;
    position: relative;
}

.day-card.today::before {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border-radius: 16px;
    background: #ffffff;
    z-index: -1;
}

body.college-theme .day-card.today {
    border-color: #0058AA;
}

body.college-theme .day-card.today::before {
    background: #ffffff;
}

.day-card-header {
    background: #ffffff;
    color: #1E1E1E;
    padding: 24px;
    border: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
}

body.college-theme .day-card-header {
    background: #ffffff;
    color: #1E1E1E;
    border: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
}

.day-card.today .day-card-header {
    border-bottom: 4px solid #009F9B;
}

body.college-theme .day-card.today .day-card-header {
    border-bottom: 4px solid #0058AA;
}

.day-card-header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.day-card-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.calendar-icon-wrapper {
    padding: 8px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    backdrop-filter: blur(10px);
}

.calendar-icon {
    font-size: 24px;
    display: block;
    color: #1E1E1E;
}

.day-card-date-info {
    display: flex;
    flex-direction: column;
    color: #1E1E1E;
}

.day-of-week {
    font-size: 16px;
    opacity: 0.9;
    margin-bottom: 4px;
    color: #1E1E1E;
}

.day-full-date {
    font-size: 18px;
    font-weight: 700;
    color: #1E1E1E;
}

.day-card-stats {
    text-align: right;
    color: #1E1E1E;
}

.stats-label {
    font-size: 14px;
    opacity: 0.9;
    margin-bottom: 4px;
    color: #1E1E1E;
}

.stats-count {
    font-size: 32px;
    font-weight: 700;
    color: #1E1E1E;
}

.day-card-content {
    padding: 24px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}

.no-lessons {
    color: #666;
    font-size: 16px;
    padding: 20px;
    text-align: center;
}

.lesson-card-modern {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e7eb;
    position: relative;
    overflow: hidden;
    transition: box-shadow 0.2s ease;
    will-change: transform;
    transform: translateZ(0);
    backface-visibility: hidden;
}

.lesson-card-modern:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.lesson-card-left-border {
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;
    background: var(--lesson-color, #009F9B);
    border-radius: 12px 0 0 12px;
}

.lesson-card-body {
    display: flex;
    gap: 16px;
    align-items: stretch;
    min-height: 100%;
}

.lesson-left-column {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    flex-shrink: 0;
}

.lesson-pair-number-box {
    width: 70px;
    min-height: 64px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    flex-shrink: 0;
    padding: 10px 2px;
}

.pair-number {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2px;
}

.pair-label {
    font-size: 12px;
    opacity: 0.95;
    text-align: center;
    margin-bottom: 8px;
    font-weight: 600;
}

.pair-time-full {
    width: 70px;
    flex: 1;
    padding: 12px 4px;
    border-radius: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    min-height: 100px;
    color: white;
}

.pair-time-start,
.pair-time-end {
    color: white;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
    text-align: center;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pair-time-separator {
    width: 100%;
    height: 1px;
    border-top: 1px dashed rgba(255, 255, 255, 0.5);
    margin: 2px 0;
}

.pair-address {
    width: 100%;
    margin-top: 8px;
    padding: 6px 4px;
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    text-align: center;
    color: white;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


.lesson-main-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.lesson-header-modern {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.lesson-subject-name {
    font-size: 22px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    line-height: 1.4;
    flex: 1;
}

.lesson-type-badge-modern {
    padding: 8px 14px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid;
    white-space: nowrap;
}

.lesson-details-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}


.lesson-detail-item-modern {
    display: flex;
    align-items: center;
    gap: 12px;
}

.detail-icon-box {
    width: 32px;
    height: 32px;
    padding: 6px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-color: #f1f5f9;
}

.detail-icon-modern {
    font-size: 16px;
    display: block;
    color: #475569;
}

.detail-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.detail-label-modern {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
}

.detail-value-modern {
    font-size: 16px;
    color: #1e293b;
    font-weight: 600;
}

.groups-more,
.groups-less {
    color: var(--lesson-color, #009F9B);
    cursor: pointer;
    text-decoration: underline;
    font-weight: 600;
    margin-left: 4px;
}

.groups-more:hover,
.groups-less:hover {
    opacity: 0.8;
}

.lesson-time-item .detail-value-modern {
    font-weight: 700;
    font-size: 15px;
    padding: 6px 10px;
    border-radius: 8px;
    display: inline-block;
    margin-top: 2px;
}

/* Цвета для УРК */

body.college-theme .tab.active {
    color: #0058AA;
    border-bottom-color: #0058AA;
}

body.college-theme .select-wrapper select:focus,
body.college-theme input[type="date"]:focus,
body.college-theme .search-wrapper input[type="text"]:focus {
    border-color: #0058AA;
}

body.college-theme .load-button {
    background-color: #0058AA;
}

body.college-theme .load-button:hover {
    background-color: #004488;
}

body.college-theme .type-badge {
    background-color: #0058AA;
}

body.college-theme .custom-select-input:focus,
body.college-theme .custom-select-search input:focus {
    border-color: #0058AA;
}

body.college-theme .custom-select-option.selected {
    background-color: #e3f2fd;
    color: #0058AA;
}

/* Применение фирменных цветов */
body {
    background-color: #f5f5f5;
}

/* Адаптивность */


/* Планшеты и меньше (до 1024px) */
@media (max-width: 1024px) {
    .main-header {
        padding: 20px 30px;
    }

    .header-logo-img {
        height: 40px;
        width: auto;
        max-width: 200px;
        max-height: 40px;
    }

    .main-content {
        flex-direction: column;
        padding: 30px;
        gap: 20px;
    }

    .main-left-section,
    .main-right-section {
        width: 100%;
        max-width: 714px;
        height: 355px;
    }

    .weekly-days-container {
        grid-template-columns: 1fr;
    }

    .schedule-content {
        padding: 15px;
    }

    /* Карточки дней */
    .day-card-title {
        gap: 10px;
    }

    .calendar-icon-wrapper {
        padding: 7px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 22px;
    }
}

/* Средние мобильные устройства (до 600px) */
@media (max-width: 600px) {
    .main-header {
        padding: 15px 18px;
        gap: 12px;
    }
    
    .header-logo-img {
        height: 32px;
        width: auto;
        max-width: 160px;
        max-height: 32px;
    }
    
    .header-logo {
        flex: 0 1 auto;
        min-width: 0;
        max-width: 45%;
        overflow: hidden;
    }
}

/* Мобильные устройства (до 768px) */
@media (max-width: 768px) {
    /* Главная страница */
    .main-header {
        padding: 15px 20px;
        flex-wrap: wrap;
        gap: 15px;
    }

    .header-logo-img {
        height: 35px;
        width: auto;
        max-width: 180px;
        max-height: 35px;
    }
    
    .header-logo {
        flex: 0 1 auto;
        min-width: 0;
        max-width: 50%;
        flex-shrink: 1;
        overflow: hidden;
    }

    .header-button {
        padding: 10px 20px;
        font-size: 14px;
    }

    .main-content {
        padding: 20px;
        gap: 15px;
    }

    .main-left-section,
    .main-right-section {
        width: 100%;
        max-width: 714px;
        height: 355px;
    }

    .section-content {
        padding: 20px;
        gap: 20px;
    }

    .title-line {
        font-size: 24px;
        line-height: 30px;
    }

    .org-button {
        padding: 14px 30px;
        font-size: 16px;
        min-width: 200px;
    }


    /* Страница расписания */
    .schedule-header {
        padding: 20px 15px;
    }

    .schedule-header h1 {
        font-size: 20px;
        padding-left: 180px;
        padding-right: 20px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
        line-height: 1.3;
    }

    .back-logo {
        left: 15px;
        margin-left: 8px;
    }

    .back-logo-img {
        width: 150px;
        height: 55px;
        max-width: 100%;
    }

    .schedule-content {
        padding: 15px 10px;
    }

    /* Вкладки */
    .tabs {
        flex-direction: row;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .tab {
        padding: 12px 20px;
        font-size: 14px;
        white-space: nowrap;
        flex-shrink: 0;
    }

    /* Фильтры */
    .filters-container {
        padding: 20px;
        margin-bottom: 20px;
    }

    .filter-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        margin-bottom: 15px;
    }

    .filter-row label {
        min-width: auto;
        width: 100%;
        font-size: 14px;
    }

    .select-wrapper,
    input[type="date"],
    .search-wrapper {
        width: 100%;
    }

    input[type="date"] {
        color: #1E1E1E;
    }

    input[type="date"]::-webkit-datetime-edit-text,
    input[type="date"]::-webkit-datetime-edit-month-field,
    input[type="date"]::-webkit-datetime-edit-day-field,
    input[type="date"]::-webkit-datetime-edit-year-field {
        color: #1E1E1E;
    }

    .load-button {
        padding: 12px;
        font-size: 15px;
    }

    /* Карточки дней */
    .weekly-days-container {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .day-card-header {
        padding: 15px;
    }

    .day-card-title {
        flex-direction: row;
        gap: 10px;
        align-items: center;
    }

    .calendar-icon-wrapper {
        padding: 7px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 21px;
    }

    .day-card-date-info {
        font-size: 14px;
    }

    .day-card-stats {
        margin-top: 10px;
    }

    .day-card-content {
        padding: 12px;
        gap: 12px;
    }

    /* Карточки занятий */
    .lesson-card-modern {
        margin-bottom: 12px;
    }

    .lesson-left-column {
        width: 60px;
    }

    .lesson-pair-number-box {
        width: 60px;
        min-height: 56px;
        padding: 8px 2px;
    }

    .pair-number {
        font-size: 18px;
    }

    .pair-time-full {
        width: 60px;
        padding: 10px 3px;
        min-height: 80px;
    }

    .pair-time-start,
    .pair-time-end {
        font-size: 13px;
    }

    .lesson-subject-name {
        font-size: 16px;
    }

    .lesson-type-badge-modern {
        font-size: 11px;
        padding: 4px 8px;
    }

    .detail-label-modern {
        font-size: 11px;
    }

    .detail-value-modern {
        font-size: 13px;
    }
}

/* Маленькие мобильные устройства (до 480px) */
@media (max-width: 480px) {
    /* Главная страница */
    .main-header {
        padding: 12px 15px;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: center;
    }

    .header-logo {
        width: 100%;
        justify-content: center;
        flex: 0 0 100%;
        order: 1;
    }

    .header-logo-img {
        height: 30px;
        width: auto;
        max-width: 150px;
        max-height: 30px;
    }
    
    .header-logo {
        width: 100%;
        max-width: 100%;
        flex: 0 0 100%;
        justify-content: center;
        overflow: hidden;
    }
    
    .header-buttons {
        order: 2;
    }

    .header-buttons {
        width: 100%;
        justify-content: center;
    }

    .header-button {
        padding: 8px 16px;
        font-size: 13px;
    }

    .main-content {
        padding: 15px;
        gap: 12px;
    }

    .main-left-section,
    .main-right-section {
        width: 100%;
        max-width: 600px;
        height: 300px;
        border-radius: 15px;
    }

    .section-content {
        padding: 15px;
        gap: 15px;
    }

    .title-line {
        font-size: 20px;
        line-height: 26px;
    }

    .org-button {
        padding: 12px 25px;
        font-size: 15px;
        min-width: 180px;
    }

    /* Страница расписания */
    .schedule-header {
        padding: 15px 10px;
    }

    .schedule-header h1 {
        font-size: 18px;
        padding-left: 140px;
        padding-right: 15px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
        line-height: 1.3;
    }

    .back-logo {
        left: 10px;
        margin-left: 5px;
    }

    .back-logo-img {
        width: 120px;
        height: 44px;
        max-width: 100%;
    }

    .schedule-content {
        padding: 10px 5px;
    }

    /* Вкладки */
    .tab {
        padding: 10px 15px;
        font-size: 13px;
    }

    /* Фильтры */
    .filters-container {
        padding: 15px;
    }

    .filter-row {
        margin-bottom: 12px;
    }

    .filter-row label {
        font-size: 13px;
    }

    .custom-select-input,
    input[type="date"] {
        font-size: 14px;
        padding: 8px 12px;
        color: #1E1E1E;
    }

    input[type="date"]::-webkit-datetime-edit-text,
    input[type="date"]::-webkit-datetime-edit-month-field,
    input[type="date"]::-webkit-datetime-edit-day-field,
    input[type="date"]::-webkit-datetime-edit-year-field {
        color: #1E1E1E;
    }

    .load-button {
        padding: 10px;
        font-size: 14px;
    }

    /* Карточки дней */
    .day-card-header {
        padding: 12px;
    }

    .day-card-title {
        gap: 6px;
        flex-direction: row;
        align-items: center;
    }

    .calendar-icon-wrapper {
        padding: 5px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 18px;
    }

    .day-card-date-info {
        font-size: 12px;
    }

    .day-card-content {
        padding: 10px;
        gap: 10px;
    }

    /* Карточки занятий */
    .lesson-left-column {
        width: 55px;
    }

    .lesson-pair-number-box {
        width: 55px;
        min-height: 50px;
    }

    .pair-number {
        font-size: 16px;
    }

    .pair-time-full {
        width: 55px;
        min-height: 70px;
    }

    .pair-time-start,
    .pair-time-end {
        font-size: 12px;
    }

    .lesson-subject-name {
        font-size: 14px;
    }

    .lesson-type-badge-modern {
        font-size: 10px;
        padding: 3px 6px;
    }

    .detail-label-modern {
        font-size: 10px;
    }

    .detail-value-modern {
        font-size: 12px;
    }

    .detail-icon-modern {
        font-size: 14px;
    }
}

/* Очень маленькие экраны (до 320px) */
@media (max-width: 320px) {
    .main-header {
        padding: 8px 10px;
        gap: 6px;
    }
    
    .header-logo-img {
        height: 24px !important;
        width: auto !important;
        max-width: 120px !important;
        max-height: 24px !important;
    }
    
    .header-logo {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        justify-content: center;
        overflow: hidden;
    }
    
    .header-button {
        padding: 6px 12px;
        font-size: 11px;
    }

    .day-card-title {
        flex-direction: row;
        align-items: center;
        gap: 6px;
    }

    .calendar-icon-wrapper {
        padding: 4px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 14px;
    }
}

/* Средние мобильные устройства (до 450px) */
@media (max-width: 450px) {
    .day-card-title {
        flex-direction: row;
        align-items: center;
        gap: 8px;
    }

    .calendar-icon-wrapper {
        padding: 6px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 19px;
    }
}

/* Средние мобильные устройства (от 450px до 500px) */
@media (min-width: 451px) and (max-width: 500px) {
    .day-card-title {
        flex-direction: row;
        align-items: center;
        gap: 9px;
    }

    .calendar-icon-wrapper {
        padding: 6px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 20px;
    }
}

/* Очень маленькие экраны (до 360px) */
@media (max-width: 360px) {
    .main-header {
        padding: 10px 12px;
        gap: 8px;
    }
    
    .header-logo-img {
        height: 28px !important;
        width: auto !important;
        max-width: 140px !important;
        max-height: 28px !important;
    }
    
    .header-logo {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        justify-content: center;
        overflow: hidden;
    }
    
    .header-button {
        padding: 8px 14px;
        font-size: 12px;
    }

    .day-card-title {
        flex-direction: row;
        align-items: center;
        gap: 8px;
    }

    .calendar-icon-wrapper {
        padding: 5px;
        flex-shrink: 0;
    }

    .calendar-icon {
        font-size: 16px;
    }
    
    .main-left-section,
    .main-right-section {
        width: 100%;
        max-width: 100%;
        height: 250px;
    }

    .title-line {
        font-size: 20px;
        line-height: 26px;
    }

    .org-button {
        min-width: 160px;
        padding: 10px 20px;
        font-size: 14px;
    }

    .schedule-header h1 {
        font-size: 16px;
        padding-left: 130px;
        padding-right: 10px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
        line-height: 1.3;
    }
    
    .back-logo-img {
        width: 100px;
        height: 36px;
        max-width: 100%;
    }

    .day-card-header {
        padding: 10px;
    }

    .day-card-content {
        padding: 8px;
    }
}

`, "",{"version":3,"sources":["webpack://./public/src/styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,yGAAyG;IACzG,6DAA6D;IAC7D,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,OAAO;IACP,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAAwC;IACxC,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yDAAwC;IACxC,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;IACzC,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,6CAA6C;AACjD;;;AAGA,wBAAwB;AACxB;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,MAAM;IACN,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yDAAuL;IACvL,4BAA4B;IAC5B,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,yDAAuL;IACvL,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,0CAA0C;IAC1C,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,OAAO;IACP,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,0CAA0C;IAC1C,yCAAyC;IACzC,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,+CAA+C;IAC/C,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,wCAAwC;AAC5C;;;AAGA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,mCAAmC;IACnC,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;AAEA,kBAAkB;;AAElB;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;;;AAGjB,kCAAkC;AAClC;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,SAAS;IACb;;IAEA;;QAEI,WAAW;QACX,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA,kBAAkB;IAClB;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA,oCAAoC;AACpC;IACI,qBAAqB;IACrB;QACI,kBAAkB;QAClB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;QACd,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;;QAEI,WAAW;QACX,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;;IAGA,wBAAwB;IACxB;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;QACrB,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA,YAAY;IACZ;QACI,mBAAmB;QACnB,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,cAAc;IAClB;;IAEA,YAAY;IACZ;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;IACnB;;IAEA;;;QAGI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;;;;QAII,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA,kBAAkB;IAClB;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA,qBAAqB;IACrB;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,8CAA8C;AAC9C;IACI,qBAAqB;IACrB;QACI,kBAAkB;QAClB,eAAe;QACf,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,cAAc;QACd,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,cAAc;QACd,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;;QAEI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA,wBAAwB;IACxB;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;QACrB,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,YAAY;IACZ;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA,YAAY;IACZ;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;;;;QAII,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA,kBAAkB;IAClB;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;QACR,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA,qBAAqB;IACrB;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,sCAAsC;AACtC;IACI;QACI,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,yBAAyB;QACzB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,qDAAqD;AACrD;IACI;QACI,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,sCAAsC;AACtC;IACI;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,yBAAyB;QACzB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;QACrB,yBAAyB;QACzB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    min-height: 100vh;\n    overflow-x: hidden;\n}\n\nhtml {\n    overflow-x: hidden;\n}\n\n.page {\n    display: none;\n    min-height: 100vh;\n}\n\n.page.active {\n    display: block;\n}\n\n/* Главная страница */\n.main-page {\n    background: #f5f7fa;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Черный хедер */\n.main-header {\n    background-color: #1E1E1E;\n    padding: 30px 40px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.header-logo {\n    display: flex;\n    align-items: center;\n    flex-shrink: 1;\n    min-width: 0;\n    overflow: hidden;\n}\n\n.header-logo-img {\n    height: 45px;\n    width: auto;\n    max-width: 100%;\n    max-height: 45px;\n    object-fit: contain;\n    display: block;\n}\n\n/* Дополнительная адаптивность для очень маленьких экранов */\n@media (max-width: 480px) {\n    .header-logo-img {\n        max-width: calc(100vw - 100px) !important;\n    }\n}\n\n@media (max-width: 360px) {\n    .header-logo-img {\n        max-width: calc(100vw - 80px) !important;\n    }\n}\n\n@media (max-width: 320px) {\n    .header-logo-img {\n        max-width: calc(100vw - 60px) !important;\n    }\n}\n\n.header-buttons {\n    display: flex;\n    gap: 15px;\n}\n\n.header-button {\n    background: #0058AA;\n    color: #ffffff;\n    text-decoration: none;\n    padding: 12px 30px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    border: none;\n    cursor: pointer;\n}\n\n.header-button:hover {\n    background-color: #004080;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 88, 170, 0.4);\n}\n\n.main-content {\n    display: flex;\n    flex: 1;\n    padding: 40px;\n    gap: 30px;\n    justify-content: center;\n    align-items: center;\n    max-width: 1500px;\n    margin: 0 auto;\n    width: 100%;\n    min-height: calc(100vh - 100px);\n}\n\n.main-left-section {\n    width: 714px;\n    height: 355px;\n    background-image: url('/img/back_2.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    border-radius: 20px;\n    overflow: hidden;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.main-right-section {\n    width: 714px;\n    height: 355px;\n    background-image: url('/img/back_1.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    border-radius: 20px;\n    overflow: hidden;\n    position: relative;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.main-left-section:hover,\n.main-right-section:hover {\n    transform: scale(1.02);\n}\n\n.main-left-section:hover::before,\n.main-right-section:hover::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.1);\n    z-index: 1;\n}\n\n.section-link {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    color: inherit;\n}\n\n.section-content {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    padding: 20px;\n    text-align: center;\n}\n\n.org-title {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin: 0;\n}\n\n.title-line {\n    font-family: 'Roboto', sans-serif;\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 34px;\n    color: white;\n    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);\n}\n\n.org-button {\n    border: none;\n    cursor: pointer;\n    padding: 12px 32px;\n    border-radius: 12px;\n    font-size: 16px;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    min-width: 220px;\n    text-decoration: none;\n    display: inline-block;\n    text-align: center;\n    pointer-events: none;\n}\n\n.org-button-white {\n    background: white;\n    color: #1e293b;\n}\n\n.section-link:hover .org-button-white.org-button-college {\n    background-color: #0058AA;\n    color: white;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 88, 170, 0.4);\n}\n\n.section-link:hover .org-button-white.org-button-university {\n    background-color: #009F9B;\n    color: white;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 159, 155, 0.4);\n}\n\n\n/* Страница расписания */\n.schedule-header {\n    background-color: #1E1E1E;\n    color: white;\n    padding: 40px 20px;\n    text-align: center;\n    position: relative;\n}\n\n.schedule-header h1 {\n    font-family: 'Roboto', sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    font-style: normal;\n    margin: 0;\n    padding-left: 240px;\n    padding-right: 240px;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    hyphens: auto;\n    line-height: 1.3;\n}\n\n.back-logo {\n    position: absolute;\n    left: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: opacity 0.3s;\n    text-decoration: none;\n    margin-left: 10px;\n}\n\n.back-logo:hover {\n    opacity: 0.8;\n}\n\n.back-logo-img {\n    width: 212px;\n    height: 77px;\n    object-fit: contain;\n    max-width: 100%;\n}\n\n.schedule-content {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n/* Вкладки */\n.tabs {\n    display: flex;\n    gap: 0;\n    background-color: white;\n    border-bottom: 2px solid #e0e0e0;\n    margin-bottom: 20px;\n    justify-content: center;\n}\n\n.tab {\n    padding: 15px 30px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    color: #666;\n    border-bottom: 3px solid transparent;\n    transition: all 0.3s;\n}\n\n.tab:hover {\n    color: #333;\n    background-color: #f9f9f9;\n}\n\n.tab.active {\n    color: #009F9B;\n    border-bottom-color: #009F9B;\n    font-weight: 500;\n}\n\n/* Фильтры */\n.filters-container {\n    background-color: white;\n    padding: 30px;\n    border-radius: 8px;\n    margin-bottom: 30px;\n}\n\n.filter-section {\n    display: none;\n}\n\n.filter-section.active {\n    display: block;\n}\n\n.filter-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    gap: 15px;\n}\n\n.filter-row label {\n    min-width: 120px;\n    font-weight: 500;\n    color: #333;\n}\n\n.select-wrapper {\n    flex: 1;\n    position: relative;\n}\n\n.select-wrapper select {\n    width: 100%;\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n    background-color: white;\n    cursor: pointer;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n    padding-right: 35px;\n}\n\n.select-wrapper select:focus {\n    outline: none;\n    border-color: #009F9B;\n}\n\ninput[type=\"date\"] {\n    flex: 1;\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n    color: #1E1E1E;\n    background-color: #ffffff;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    cursor: pointer;\n}\n\ninput[type=\"date\"]::-webkit-datetime-edit-text {\n    color: #1E1E1E;\n}\n\ninput[type=\"date\"]::-webkit-datetime-edit-month-field,\ninput[type=\"date\"]::-webkit-datetime-edit-day-field,\ninput[type=\"date\"]::-webkit-datetime-edit-year-field {\n    color: #1E1E1E;\n}\n\ninput[type=\"date\"]:focus {\n    outline: none;\n    border-color: #009F9B;\n}\n\n.search-wrapper {\n    flex: 1;\n    position: relative;\n}\n\n.custom-select {\n    position: relative;\n    width: 100%;\n}\n\n.custom-select-input {\n    width: 100%;\n    padding: 10px 35px 10px 15px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 16px;\n    background-color: white;\n    cursor: pointer;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 10px center;\n}\n\n.custom-select-input:focus {\n    outline: none;\n    border-color: #009F9B;\n}\n\n.custom-select-dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #ddd;\n    border-top: none;\n    border-radius: 0 0 4px 4px;\n    max-height: 300px;\n    overflow-y: auto;\n    z-index: 1000;\n    display: none;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.custom-select-dropdown.active {\n    display: block;\n}\n\n.custom-select-search {\n    padding: 10px;\n    border-bottom: 1px solid #e0e0e0;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 1;\n}\n\n.custom-select-search input {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.custom-select-search input:focus {\n    outline: none;\n    border-color: #009F9B;\n}\n\n.custom-select-options {\n    max-height: 250px;\n    overflow-y: auto;\n}\n\n.custom-select-option {\n    padding: 10px 15px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.custom-select-option:hover {\n    background-color: #f5f5f5;\n}\n\n.custom-select-option.selected {\n    background-color: #e3f2fd;\n    color: #009F9B;\n    font-weight: 500;\n}\n\n.custom-select-option.hidden {\n    display: none;\n}\n\n.load-button {\n    width: 100%;\n    padding: 15px;\n    background-color: #009F9B;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    margin-top: 10px;\n    transition: background-color 0.3s;\n}\n\n.load-button:hover {\n    background-color: #007a77;\n}\n\n.load-button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n/* Отображение расписания */\n.schedule-display {\n    margin-top: 30px;\n}\n\n.weekly-schedule {\n    margin-top: 30px;\n    padding-bottom: 40px;\n}\n\n.weekly-header {\n    margin-bottom: 25px;\n    text-align: center;\n}\n\n.weekly-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #1a1a1a;\n    margin-bottom: 8px;\n}\n\n.weekly-date-range {\n    font-size: 16px;\n    color: #666;\n    font-weight: 500;\n}\n\n.weekly-days-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n    padding-bottom: 10px;\n    will-change: scroll-position;\n    contain: layout style paint;\n}\n\n.day-card {\n    background: #ffffff;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);\n    border: none;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    will-change: transform;\n    transform: translateZ(0);\n    backface-visibility: hidden;\n}\n\n.day-card.today {\n    border: 4px solid #009F9B;\n    position: relative;\n}\n\n.day-card.today::before {\n    content: '';\n    position: absolute;\n    top: -3px;\n    left: -3px;\n    right: -3px;\n    bottom: -3px;\n    border-radius: 16px;\n    background: #ffffff;\n    z-index: -1;\n}\n\nbody.college-theme .day-card.today {\n    border-color: #0058AA;\n}\n\nbody.college-theme .day-card.today::before {\n    background: #ffffff;\n}\n\n.day-card-header {\n    background: #ffffff;\n    color: #1E1E1E;\n    padding: 24px;\n    border: 1px solid #e5e7eb;\n    border-bottom: 1px solid #e5e7eb;\n}\n\nbody.college-theme .day-card-header {\n    background: #ffffff;\n    color: #1E1E1E;\n    border: 1px solid #e5e7eb;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.day-card.today .day-card-header {\n    border-bottom: 4px solid #009F9B;\n}\n\nbody.college-theme .day-card.today .day-card-header {\n    border-bottom: 4px solid #0058AA;\n}\n\n.day-card-header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.day-card-title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.calendar-icon-wrapper {\n    padding: 8px;\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 8px;\n    backdrop-filter: blur(10px);\n}\n\n.calendar-icon {\n    font-size: 24px;\n    display: block;\n    color: #1E1E1E;\n}\n\n.day-card-date-info {\n    display: flex;\n    flex-direction: column;\n    color: #1E1E1E;\n}\n\n.day-of-week {\n    font-size: 16px;\n    opacity: 0.9;\n    margin-bottom: 4px;\n    color: #1E1E1E;\n}\n\n.day-full-date {\n    font-size: 18px;\n    font-weight: 700;\n    color: #1E1E1E;\n}\n\n.day-card-stats {\n    text-align: right;\n    color: #1E1E1E;\n}\n\n.stats-label {\n    font-size: 14px;\n    opacity: 0.9;\n    margin-bottom: 4px;\n    color: #1E1E1E;\n}\n\n.stats-count {\n    font-size: 32px;\n    font-weight: 700;\n    color: #1E1E1E;\n}\n\n.day-card-content {\n    padding: 24px;\n    background: #ffffff;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n}\n\n.no-lessons {\n    color: #666;\n    font-size: 16px;\n    padding: 20px;\n    text-align: center;\n}\n\n.lesson-card-modern {\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n    border: 1px solid #e5e7eb;\n    position: relative;\n    overflow: hidden;\n    transition: box-shadow 0.2s ease;\n    will-change: transform;\n    transform: translateZ(0);\n    backface-visibility: hidden;\n}\n\n.lesson-card-modern:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.lesson-card-left-border {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 6px;\n    height: 100%;\n    background: var(--lesson-color, #009F9B);\n    border-radius: 12px 0 0 12px;\n}\n\n.lesson-card-body {\n    display: flex;\n    gap: 16px;\n    align-items: stretch;\n    min-height: 100%;\n}\n\n.lesson-left-column {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.lesson-pair-number-box {\n    width: 70px;\n    min-height: 64px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    flex-shrink: 0;\n    padding: 10px 2px;\n}\n\n.pair-number {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: center;\n    margin-bottom: 2px;\n}\n\n.pair-label {\n    font-size: 12px;\n    opacity: 0.95;\n    text-align: center;\n    margin-bottom: 8px;\n    font-weight: 600;\n}\n\n.pair-time-full {\n    width: 70px;\n    flex: 1;\n    padding: 12px 4px;\n    border-radius: 12px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n    box-sizing: border-box;\n    min-height: 100px;\n    color: white;\n}\n\n.pair-time-start,\n.pair-time-end {\n    color: white;\n    font-size: 15px;\n    font-weight: 700;\n    line-height: 1.3;\n    text-align: center;\n    width: 100%;\n    padding: 0;\n    box-sizing: border-box;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.pair-time-separator {\n    width: 100%;\n    height: 1px;\n    border-top: 1px dashed rgba(255, 255, 255, 0.5);\n    margin: 2px 0;\n}\n\n.pair-address {\n    width: 100%;\n    margin-top: 8px;\n    padding: 6px 4px;\n    background-color: rgba(255, 255, 255, 0.15);\n    border-radius: 8px;\n    text-align: center;\n    color: white;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.3;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n\n.lesson-main-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.lesson-header-modern {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.lesson-subject-name {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1e293b;\n    margin: 0;\n    line-height: 1.4;\n    flex: 1;\n}\n\n.lesson-type-badge-modern {\n    padding: 8px 14px;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 600;\n    border: 1px solid;\n    white-space: nowrap;\n}\n\n.lesson-details-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n}\n\n\n.lesson-detail-item-modern {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.detail-icon-box {\n    width: 32px;\n    height: 32px;\n    padding: 6px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background-color: #f1f5f9;\n}\n\n.detail-icon-modern {\n    font-size: 16px;\n    display: block;\n    color: #475569;\n}\n\n.detail-content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.detail-label-modern {\n    font-size: 13px;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.detail-value-modern {\n    font-size: 16px;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.groups-more,\n.groups-less {\n    color: var(--lesson-color, #009F9B);\n    cursor: pointer;\n    text-decoration: underline;\n    font-weight: 600;\n    margin-left: 4px;\n}\n\n.groups-more:hover,\n.groups-less:hover {\n    opacity: 0.8;\n}\n\n.lesson-time-item .detail-value-modern {\n    font-weight: 700;\n    font-size: 15px;\n    padding: 6px 10px;\n    border-radius: 8px;\n    display: inline-block;\n    margin-top: 2px;\n}\n\n/* Цвета для УРК */\n\nbody.college-theme .tab.active {\n    color: #0058AA;\n    border-bottom-color: #0058AA;\n}\n\nbody.college-theme .select-wrapper select:focus,\nbody.college-theme input[type=\"date\"]:focus,\nbody.college-theme .search-wrapper input[type=\"text\"]:focus {\n    border-color: #0058AA;\n}\n\nbody.college-theme .load-button {\n    background-color: #0058AA;\n}\n\nbody.college-theme .load-button:hover {\n    background-color: #004488;\n}\n\nbody.college-theme .type-badge {\n    background-color: #0058AA;\n}\n\nbody.college-theme .custom-select-input:focus,\nbody.college-theme .custom-select-search input:focus {\n    border-color: #0058AA;\n}\n\nbody.college-theme .custom-select-option.selected {\n    background-color: #e3f2fd;\n    color: #0058AA;\n}\n\n/* Применение фирменных цветов */\nbody {\n    background-color: #f5f5f5;\n}\n\n/* Адаптивность */\n\n\n/* Планшеты и меньше (до 1024px) */\n@media (max-width: 1024px) {\n    .main-header {\n        padding: 20px 30px;\n    }\n\n    .header-logo-img {\n        height: 40px;\n        width: auto;\n        max-width: 200px;\n        max-height: 40px;\n    }\n\n    .main-content {\n        flex-direction: column;\n        padding: 30px;\n        gap: 20px;\n    }\n\n    .main-left-section,\n    .main-right-section {\n        width: 100%;\n        max-width: 714px;\n        height: 355px;\n    }\n\n    .weekly-days-container {\n        grid-template-columns: 1fr;\n    }\n\n    .schedule-content {\n        padding: 15px;\n    }\n\n    /* Карточки дней */\n    .day-card-title {\n        gap: 10px;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 7px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 22px;\n    }\n}\n\n/* Средние мобильные устройства (до 600px) */\n@media (max-width: 600px) {\n    .main-header {\n        padding: 15px 18px;\n        gap: 12px;\n    }\n    \n    .header-logo-img {\n        height: 32px;\n        width: auto;\n        max-width: 160px;\n        max-height: 32px;\n    }\n    \n    .header-logo {\n        flex: 0 1 auto;\n        min-width: 0;\n        max-width: 45%;\n        overflow: hidden;\n    }\n}\n\n/* Мобильные устройства (до 768px) */\n@media (max-width: 768px) {\n    /* Главная страница */\n    .main-header {\n        padding: 15px 20px;\n        flex-wrap: wrap;\n        gap: 15px;\n    }\n\n    .header-logo-img {\n        height: 35px;\n        width: auto;\n        max-width: 180px;\n        max-height: 35px;\n    }\n    \n    .header-logo {\n        flex: 0 1 auto;\n        min-width: 0;\n        max-width: 50%;\n        flex-shrink: 1;\n        overflow: hidden;\n    }\n\n    .header-button {\n        padding: 10px 20px;\n        font-size: 14px;\n    }\n\n    .main-content {\n        padding: 20px;\n        gap: 15px;\n    }\n\n    .main-left-section,\n    .main-right-section {\n        width: 100%;\n        max-width: 714px;\n        height: 355px;\n    }\n\n    .section-content {\n        padding: 20px;\n        gap: 20px;\n    }\n\n    .title-line {\n        font-size: 24px;\n        line-height: 30px;\n    }\n\n    .org-button {\n        padding: 14px 30px;\n        font-size: 16px;\n        min-width: 200px;\n    }\n\n\n    /* Страница расписания */\n    .schedule-header {\n        padding: 20px 15px;\n    }\n\n    .schedule-header h1 {\n        font-size: 20px;\n        padding-left: 180px;\n        padding-right: 20px;\n        word-wrap: break-word;\n        overflow-wrap: break-word;\n        hyphens: auto;\n        line-height: 1.3;\n    }\n\n    .back-logo {\n        left: 15px;\n        margin-left: 8px;\n    }\n\n    .back-logo-img {\n        width: 150px;\n        height: 55px;\n        max-width: 100%;\n    }\n\n    .schedule-content {\n        padding: 15px 10px;\n    }\n\n    /* Вкладки */\n    .tabs {\n        flex-direction: row;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .tab {\n        padding: 12px 20px;\n        font-size: 14px;\n        white-space: nowrap;\n        flex-shrink: 0;\n    }\n\n    /* Фильтры */\n    .filters-container {\n        padding: 20px;\n        margin-bottom: 20px;\n    }\n\n    .filter-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        margin-bottom: 15px;\n    }\n\n    .filter-row label {\n        min-width: auto;\n        width: 100%;\n        font-size: 14px;\n    }\n\n    .select-wrapper,\n    input[type=\"date\"],\n    .search-wrapper {\n        width: 100%;\n    }\n\n    input[type=\"date\"] {\n        color: #1E1E1E;\n    }\n\n    input[type=\"date\"]::-webkit-datetime-edit-text,\n    input[type=\"date\"]::-webkit-datetime-edit-month-field,\n    input[type=\"date\"]::-webkit-datetime-edit-day-field,\n    input[type=\"date\"]::-webkit-datetime-edit-year-field {\n        color: #1E1E1E;\n    }\n\n    .load-button {\n        padding: 12px;\n        font-size: 15px;\n    }\n\n    /* Карточки дней */\n    .weekly-days-container {\n        grid-template-columns: 1fr;\n        gap: 16px;\n    }\n\n    .day-card-header {\n        padding: 15px;\n    }\n\n    .day-card-title {\n        flex-direction: row;\n        gap: 10px;\n        align-items: center;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 7px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 21px;\n    }\n\n    .day-card-date-info {\n        font-size: 14px;\n    }\n\n    .day-card-stats {\n        margin-top: 10px;\n    }\n\n    .day-card-content {\n        padding: 12px;\n        gap: 12px;\n    }\n\n    /* Карточки занятий */\n    .lesson-card-modern {\n        margin-bottom: 12px;\n    }\n\n    .lesson-left-column {\n        width: 60px;\n    }\n\n    .lesson-pair-number-box {\n        width: 60px;\n        min-height: 56px;\n        padding: 8px 2px;\n    }\n\n    .pair-number {\n        font-size: 18px;\n    }\n\n    .pair-time-full {\n        width: 60px;\n        padding: 10px 3px;\n        min-height: 80px;\n    }\n\n    .pair-time-start,\n    .pair-time-end {\n        font-size: 13px;\n    }\n\n    .lesson-subject-name {\n        font-size: 16px;\n    }\n\n    .lesson-type-badge-modern {\n        font-size: 11px;\n        padding: 4px 8px;\n    }\n\n    .detail-label-modern {\n        font-size: 11px;\n    }\n\n    .detail-value-modern {\n        font-size: 13px;\n    }\n}\n\n/* Маленькие мобильные устройства (до 480px) */\n@media (max-width: 480px) {\n    /* Главная страница */\n    .main-header {\n        padding: 12px 15px;\n        flex-wrap: wrap;\n        gap: 10px;\n        justify-content: center;\n    }\n\n    .header-logo {\n        width: 100%;\n        justify-content: center;\n        flex: 0 0 100%;\n        order: 1;\n    }\n\n    .header-logo-img {\n        height: 30px;\n        width: auto;\n        max-width: 150px;\n        max-height: 30px;\n    }\n    \n    .header-logo {\n        width: 100%;\n        max-width: 100%;\n        flex: 0 0 100%;\n        justify-content: center;\n        overflow: hidden;\n    }\n    \n    .header-buttons {\n        order: 2;\n    }\n\n    .header-buttons {\n        width: 100%;\n        justify-content: center;\n    }\n\n    .header-button {\n        padding: 8px 16px;\n        font-size: 13px;\n    }\n\n    .main-content {\n        padding: 15px;\n        gap: 12px;\n    }\n\n    .main-left-section,\n    .main-right-section {\n        width: 100%;\n        max-width: 600px;\n        height: 300px;\n        border-radius: 15px;\n    }\n\n    .section-content {\n        padding: 15px;\n        gap: 15px;\n    }\n\n    .title-line {\n        font-size: 20px;\n        line-height: 26px;\n    }\n\n    .org-button {\n        padding: 12px 25px;\n        font-size: 15px;\n        min-width: 180px;\n    }\n\n    /* Страница расписания */\n    .schedule-header {\n        padding: 15px 10px;\n    }\n\n    .schedule-header h1 {\n        font-size: 18px;\n        padding-left: 140px;\n        padding-right: 15px;\n        word-wrap: break-word;\n        overflow-wrap: break-word;\n        hyphens: auto;\n        line-height: 1.3;\n    }\n\n    .back-logo {\n        left: 10px;\n        margin-left: 5px;\n    }\n\n    .back-logo-img {\n        width: 120px;\n        height: 44px;\n        max-width: 100%;\n    }\n\n    .schedule-content {\n        padding: 10px 5px;\n    }\n\n    /* Вкладки */\n    .tab {\n        padding: 10px 15px;\n        font-size: 13px;\n    }\n\n    /* Фильтры */\n    .filters-container {\n        padding: 15px;\n    }\n\n    .filter-row {\n        margin-bottom: 12px;\n    }\n\n    .filter-row label {\n        font-size: 13px;\n    }\n\n    .custom-select-input,\n    input[type=\"date\"] {\n        font-size: 14px;\n        padding: 8px 12px;\n        color: #1E1E1E;\n    }\n\n    input[type=\"date\"]::-webkit-datetime-edit-text,\n    input[type=\"date\"]::-webkit-datetime-edit-month-field,\n    input[type=\"date\"]::-webkit-datetime-edit-day-field,\n    input[type=\"date\"]::-webkit-datetime-edit-year-field {\n        color: #1E1E1E;\n    }\n\n    .load-button {\n        padding: 10px;\n        font-size: 14px;\n    }\n\n    /* Карточки дней */\n    .day-card-header {\n        padding: 12px;\n    }\n\n    .day-card-title {\n        gap: 6px;\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 5px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 18px;\n    }\n\n    .day-card-date-info {\n        font-size: 12px;\n    }\n\n    .day-card-content {\n        padding: 10px;\n        gap: 10px;\n    }\n\n    /* Карточки занятий */\n    .lesson-left-column {\n        width: 55px;\n    }\n\n    .lesson-pair-number-box {\n        width: 55px;\n        min-height: 50px;\n    }\n\n    .pair-number {\n        font-size: 16px;\n    }\n\n    .pair-time-full {\n        width: 55px;\n        min-height: 70px;\n    }\n\n    .pair-time-start,\n    .pair-time-end {\n        font-size: 12px;\n    }\n\n    .lesson-subject-name {\n        font-size: 14px;\n    }\n\n    .lesson-type-badge-modern {\n        font-size: 10px;\n        padding: 3px 6px;\n    }\n\n    .detail-label-modern {\n        font-size: 10px;\n    }\n\n    .detail-value-modern {\n        font-size: 12px;\n    }\n\n    .detail-icon-modern {\n        font-size: 14px;\n    }\n}\n\n/* Очень маленькие экраны (до 320px) */\n@media (max-width: 320px) {\n    .main-header {\n        padding: 8px 10px;\n        gap: 6px;\n    }\n    \n    .header-logo-img {\n        height: 24px !important;\n        width: auto !important;\n        max-width: 120px !important;\n        max-height: 24px !important;\n    }\n    \n    .header-logo {\n        width: 100% !important;\n        max-width: 100% !important;\n        flex: 0 0 100% !important;\n        justify-content: center;\n        overflow: hidden;\n    }\n    \n    .header-button {\n        padding: 6px 12px;\n        font-size: 11px;\n    }\n\n    .day-card-title {\n        flex-direction: row;\n        align-items: center;\n        gap: 6px;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 4px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 14px;\n    }\n}\n\n/* Средние мобильные устройства (до 450px) */\n@media (max-width: 450px) {\n    .day-card-title {\n        flex-direction: row;\n        align-items: center;\n        gap: 8px;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 6px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 19px;\n    }\n}\n\n/* Средние мобильные устройства (от 450px до 500px) */\n@media (min-width: 451px) and (max-width: 500px) {\n    .day-card-title {\n        flex-direction: row;\n        align-items: center;\n        gap: 9px;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 6px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 20px;\n    }\n}\n\n/* Очень маленькие экраны (до 360px) */\n@media (max-width: 360px) {\n    .main-header {\n        padding: 10px 12px;\n        gap: 8px;\n    }\n    \n    .header-logo-img {\n        height: 28px !important;\n        width: auto !important;\n        max-width: 140px !important;\n        max-height: 28px !important;\n    }\n    \n    .header-logo {\n        width: 100% !important;\n        max-width: 100% !important;\n        flex: 0 0 100% !important;\n        justify-content: center;\n        overflow: hidden;\n    }\n    \n    .header-button {\n        padding: 8px 14px;\n        font-size: 12px;\n    }\n\n    .day-card-title {\n        flex-direction: row;\n        align-items: center;\n        gap: 8px;\n    }\n\n    .calendar-icon-wrapper {\n        padding: 5px;\n        flex-shrink: 0;\n    }\n\n    .calendar-icon {\n        font-size: 16px;\n    }\n    \n    .main-left-section,\n    .main-right-section {\n        width: 100%;\n        max-width: 100%;\n        height: 250px;\n    }\n\n    .title-line {\n        font-size: 20px;\n        line-height: 26px;\n    }\n\n    .org-button {\n        min-width: 160px;\n        padding: 10px 20px;\n        font-size: 14px;\n    }\n\n    .schedule-header h1 {\n        font-size: 16px;\n        padding-left: 130px;\n        padding-right: 10px;\n        word-wrap: break-word;\n        overflow-wrap: break-word;\n        hyphens: auto;\n        line-height: 1.3;\n    }\n    \n    .back-logo-img {\n        width: 100px;\n        height: 36px;\n        max-width: 100%;\n    }\n\n    .day-card-header {\n        padding: 10px;\n    }\n\n    .day-card-content {\n        padding: 8px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
